export const parseDateFilter = (date: Date): string => {
  const d: Date = new Date(date)
  let month: string = '' + (d.getMonth() + 1)
  let day: string = '' + d.getDate()
  const year: number = d.getFullYear()

  month = month.padStart(2, '0')
  day = day.padStart(2, '0')

  return [year, month, day].join('-')
}
